import React from "react";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import { DoorGlassMaterial } from "../../../../../shared/utils/door";
import {
  getDeMaasBeamY,
  getDeMaasLayoutMetrics,
} from "../layouts/deMaasLayoutUtils";
import { PaneelGLTFResult } from "./PaneelType";

interface BeamProps {
  doorNodes: PaneelGLTFResult["nodes"];
  materials: DoorGlassMaterial;
  width: number;
  visible?: boolean;
}

// Default values for De Maas 2 Dubbel layout at default height 2560
const deMaasTopBeamY = 1.9;
const deMaasBottomBeamY = 0.67;
const PaneelDeMaas2DubbelBeam: React.FC<BeamProps> = ({
  doorNodes,
  materials,
  width,

  visible = true,
}: BeamProps) => {
  const { getConfigurationColor, getConfigurationHeight } =
    useConfigurationOptionsContext();

  const currentHeight = getConfigurationHeight(0);
  const metrics = getDeMaasLayoutMetrics(width, currentHeight);

  const material = materials[getConfigurationColor()];

  const beamYTop = getDeMaasBeamY(deMaasTopBeamY, metrics);
  const beamYBottom = getDeMaasBeamY(deMaasBottomBeamY, metrics);

  return (
    <group visible={visible}>
      {/* Top beam above DeMaas circle */}
      <mesh
        castShadow
        receiveShadow
        geometry={doorNodes["beam"].geometry}
        material={material}
        scale-y={metrics.scale}
        scale-x={metrics.scale}
        position={[0, beamYTop, 0]}
      />
      {/* Bottom beam below DeMaas circle */}
      <mesh
        castShadow
        receiveShadow
        geometry={doorNodes["beam"].geometry}
        material={material}
        scale-y={metrics.scale}
        scale-x={metrics.scale}
        position={[0, beamYBottom, 0]}
      />
    </group>
  );
};

export default PaneelDeMaas2DubbelBeam;
